import { FormControl } from 'react-bootstrap';
import styled from 'styled-components';

import ChevronDownIcon from '../../assets/images/icons/chevron-down.svg';

export const DatalistInput = styled(FormControl)`
  padding-right: 32px;
  background-image: url(${ChevronDownIcon});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px 16px;

  &::-webkit-calendar-picker-indicator {
    display: none !important;
  }
`;
